<template>

  <div>
    <el-button v-if="isManager('project|management|finance') && rowData.count == 0 || isSuper()" icon="fa fa-trash-alt" @click="deleteEntry()" size="small" type="danger" circle></el-button>
  </div>

  </template>



  <script>

  import PostMixins from '@/mixins/PostMixins'

  export default {
    mixins: [PostMixins],

    props: {

      rowData: {
        type: Object,
        required: true
      },

      tableRef: {
        type: String,
        default: 'backhaultable'
      }


    },


    methods: {

      deleteEntry () {
//        console.log('bh', this.rowData)
        this.deleteItem(this, this.rowData.id, '/backhaul' + (this.rowData.organisation_id ? '/subscribers' : ''),
         this.rowData.provider.shortName + ': ' +
         (!this.rowData.organisation_id
           ? this.rowData.backhaulType + ' and <b>ALL subscriber</b> data as well!'
           : this.rowData.backhaul.backhaulType + ' for ' + this.rowData.subscriber.shortName),
           this.onDelete)
      },

      onDelete (response) {
        this.$events.emit(this.tableRef + '-refresh-table')
        this.$emit('update-stats')
      }
    }

  }
  </script>

  <style>
  .item {
    margin-top: 10px;
    margin-right: 40px;
  }
  </style>
